var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('byted-button',{class:[{ ['is-loading']: _vm.loading }, `common_popup_confirm`],attrs:{"type":"primary","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.handleConfirm}},[_vm._v("\n  "+_vm._s(_vm.$t('common_confirm'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }